import { Heading } from '@/components/catalyst-ui/heading'
import { Text } from '@/components/catalyst-ui/text'
import { RadioGroup, RadioField, Radio } from '@/components/catalyst-ui/radio'
import { Badge } from '@/components/catalyst-ui/badge'
import PaymentSummary from './PaymentSummary'
import { calculatePeriodPrice, getPerYearPrice } from '../utils/priceCalculations'

export default function PeriodStep({ formData, setFormData, domain, domainPriceData }) {
  const handlePeriodChange = (period) => setFormData(prev => ({ ...prev, period: parseInt(period) }))

  const basePrice = domainPriceData?.price || 0
  const prices = domainPriceData?.prices || {}

  const periods = [
    {
      value: 1,
      label: '1 Year',
      price: calculatePeriodPrice(1, basePrice, prices),
    },
    {
      value: 2,
      label: '2 Years',
      price: calculatePeriodPrice(2, basePrice, prices),
      tag: 'SAVE 5%'
    },
    {
      value: 3,
      label: '3 Years',
      price: calculatePeriodPrice(3, basePrice, prices),
      tag: 'SAVE 5%'
    },
  ]

  const selected = periods.find(p => p.value === formData.period)
  const total = selected ? selected.price : calculatePeriodPrice(formData.period, basePrice, prices)
  const perYear = getPerYearPrice(total, formData.period)

  return (
    <div className="flex flex-col items-center">
      <div className="text-center mb-4">
        <Heading level={3} className="!text-3xl font-semibold text-gray-900">{domain} will soon be yours</Heading>
        <Text className="mt-2 !text-[#A1A1AA] !font-medium">Choose how long you want to register the domain.</Text>
      </div>

      {/* Price section - middle */}
      <div className="w-full sm:w-[443px] flex flex-col gap-[10px] mb-4">
        <style>{`
          .custom-radio-override [data-slot="control"] > span {
            --radio-checked-bg: #5C33FF !important;
            --radio-checked-border: #5C33FF !important;
          }
        `}</style>
        <RadioGroup
          value={formData.period}
          onChange={(value) => handlePeriodChange(value)}
          className="custom-radio-override"
        >
          <div className="flex flex-col gap-[6px]">
            {periods.map((p) => {
              const isSelected = formData.period === p.value
              return (
                <div
                  key={p.value}
                  className={`rounded-lg border-2 p-3 transition-colors cursor-pointer relative ${
                    isSelected ? 'border-[#5C33FF] bg-[#5C33FF]/5' : 'border-[#E4E4E7] bg-[#FAFAFA]'
                  }`}
                  onClick={() => handlePeriodChange(p.value)}
                >
                  <RadioField>
                    <Radio 
                      value={p.value} 
                      color="violet" 
                      data-slot="control"
                    />
                    <div data-slot="label" className="flex-1">
                      <div className="text-sm font-semibold text-zinc-900 dark:text-white">{p.label}</div>
                      <div className="text-sm font-medium text-[#71717A]">${(p.price).toFixed(2)}/year</div>
                    </div>
                  </RadioField>
                  {p.tag && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2">
                      <Badge color="green" className="!text-xs !font-semibold !py-1 !px-1.5 !bg-[#D1FAE5] !text-[#047857]">
                        {p.tag}
                      </Badge>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </RadioGroup>
      </div>

      {/* Summary section - bottom */}
      <PaymentSummary
        items={[
          {
            label: `${formData.period} Year ($${perYear.toFixed(2)}/year):`,
            price: total
          }
        ]}
        total={total}
        showPerYear={false}
      />
    </div>
  )
}